import {history} from '@umijs/max';

export function saveToken(token: string): void {
  localStorage.setItem('token', token);
}

export function removeToken() {
  localStorage.clear();
  history.push('/user/login');
}

export function getToken() {
  const token: string | null = localStorage.getItem('token');
  if (!token) {
    removeToken();
    return null;
  }

  return token;
}

export function checkLogin() {
  return getToken() !== undefined;
}

export function saveUser(user: API.LoginToken) {
  localStorage.setItem('user', JSON.stringify(user));
}

export function getUser(): API.LoginToken | undefined {
  if (checkLogin()) {
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      removeToken();
      return undefined;
    }
    return JSON.parse(userStr);
  }
  removeToken();
  return undefined;
}

export function hasAnyRole(roleNameArray: string[]): boolean {
  const user = getUser();
  return (
    user?.roles?.some((roleName) =>
      roleNameArray.some((r) => r === roleName),
    ) || false
  );
}

export function saveLoginInfo(loginInfo: API.LoginResult) {
  if (loginInfo && loginInfo.success && loginInfo.data) {
    const token: API.TokenInfo = {
      access_token: loginInfo.access_token,
      expires_in: loginInfo.expires_in,
      token_type: loginInfo.token_type,
      createTime: Date.now(),
    };
    saveToken(token);
    saveUser(loginInfo.data);
  }
}
